import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Lottie from 'react-lottie';
import star from '../../src/assets/images/stars.json';
import { Helmet } from 'react-helmet';
import { verifyEmail } from '../services/apiServices';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: star,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EmailConfirmation() {
  const [message, setMessage] = useState('');
  const query = useQuery();

  useEffect(() => {
    const confirmationToken = query.get('token');
    if (confirmationToken) {
      emailVerification(confirmationToken);
    }
  }, []);

  const emailVerification = (token) => {
    verifyEmail(token)
      .then((response) => {
        console.log(response);
        setMessage(response.message);
      })
      .catch((error) => {
        console.log(error.response);
        setMessage(error.response.data.message);
      });
  };

  return (
    <div className='email_verify'>
      <Helmet>
        <title>User Email Confirmation | MetaRx</title>
        
      </Helmet>
      <Lottie options={defaultOptions} width={250} height='50%' />
      <div className='email_verify_message'>{message}</div>
    </div>
  );
}

export default EmailConfirmation;
